import { AbstractControl } from '@angular/forms';

export const EMPTY_OPTIONS_HINTS = {
  notifications: 'modules.workflow.hints.noNotifications',
  roles: 'modules.workflow.hints.noRoles',
  forms: 'modules.workflow.hints.noForms',
  transitions: 'modules.workflow.hints.noTransitions',
  draftTransitions: 'modules.workflow.hints.noDraftTransitions',
  freeFields: 'modules.workflow.hints.noFreeFields',
  fields: 'modules.hints.noFields',
  dateFields: 'modules.hints.noDateFields',
  selfRelation: 'modules.hints.noSelfRelation',
  numberFields: 'modules.hints.noNumberFields',
  startScreens: 'modules.hints.noStartScreens',
  presetNumbers: 'modules.hints.noPresetNumbers',
} as const;

export const NONE_OPTION_LABEL = 'cipoFields.none';

export const hintWhenEmpty = (options: unknown[], hint: string): string => (options?.length ? undefined : hint);

const holdsValue = (value: unknown): boolean =>
  Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== false;

export const disableIfUnusable = (control: AbstractControl, usable: boolean): void => {
  if (!usable && !holdsValue(control.value)) {
    control.disable({ emitEvent: false });
  }
};
